import { isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import getCountryIso2 from 'country-iso-3-to-2';
import {
  createPersonCountry,
  updatePersonCountry,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';
import { selectApplication } from '../store/selectors/applicationSelectors';
import { BASIC_ACCOUNT_UPGRADE_TYPES } from '../util/constants';

const usePersonIdentityCountryDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();
  const Application = useSelector(selectApplication);

  const personIdentityCountryDispatch = ({
    personUid,
    data,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const { AccountUpgradeType } = Application;
    const isUpgrade =
      AccountUpgradeType === BASIC_ACCOUNT_UPGRADE_TYPES.IN_PROCESS;
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip && !isUpgrade) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      PersonUid: personUid,
      data: {
        CountryIso3Code: data?.IdentityCountry?.value,
        CountryIso2Code: getCountryIso2(data?.IdentityCountry?.value),
      },
      onSuccess,
      onError,
    };

    if (defaultValues?.IdentityCountry?.value && !isUpgrade) {
      dispatch(
        updatePersonCountry({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createPersonCountry({
        ...requestData,
      }),
    );
  };

  return { personIdentityCountryDispatch };
};

export default usePersonIdentityCountryDispatch;
